import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SuggestedSkeleton = () => {
  return (
    <div className="SuggestedSkeleton" style={{ padding: '2rem 1rem' }}>
      <div className="SuggestedSkeleton__header" style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <Skeleton height={32} width="200px" style={{ margin: '0 auto' }} />
      </div>
      
      <div className="SuggestedSkeleton__grid" style={{ 
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '1.5rem',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {Array(6).fill().map((_, index) => (
          <div key={index} className="SuggestedSkeleton__item">
            {/* Imagen principal con overlay de nivel */}
            <div style={{ position: 'relative', marginBottom: '12px' }}>
              <Skeleton 
                height={200} 
                width="100%" 
                style={{ borderRadius: '12px' }} 
              />
              {/* Skeleton para el nivel (gold/platinum) */}
              <div style={{ 
                position: 'absolute', 
                top: '8px', 
                right: '8px' 
              }}>
                <Skeleton height={24} width={60} style={{ borderRadius: '12px' }} />
              </div>
            </div>
            
            {/* Título de la propiedad */}
            <Skeleton 
              height={20} 
              width="85%" 
              style={{ marginBottom: '8px' }} 
            />
            
            {/* Ubicación */}
            <Skeleton 
              height={16} 
              width="65%" 
              style={{ marginBottom: '12px' }} 
            />
            
            {/* Rating y precio en la misma línea */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <Skeleton height={16} width="80px" />
              <Skeleton height={18} width="60px" />
            </div>
            
            {/* Botón de promoción */}
            <Skeleton 
              height={32} 
              width="120px" 
              style={{ borderRadius: '16px' }} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SuggestedSkeleton);